import { forwardRef, createElement } from 'react';
var Airform = /*#__PURE__*/
forwardRef(function (props, ref) {
  return createElement("form", Object.assign({}, props, {
    action: "https://airform.io/" + (props.email || ''),
    ref: ref,
    method: "post"
  }));
});
Airform.displayName = 'Airform';
export default Airform;